export default function DataStoreFactory(deps) {
  return {
    get(key) {
      const data = localStorage.getItem(key);
      return key === 'user' ? JSON.parse(data) : data;
    },
    set(key, value) {
      localStorage.setItem(key, key === 'user' ? JSON.stringify(value) : value);
    },
    delete(key) {
      localStorage.removeItem(key);
    }
  };
}
